import React from "react";
import StepperItem from "./stepper-item";
import { StepperInterface } from "../../models/interfaces/stepper-item.interface";
import StepperProgressBar from "../../assets/svg/stepper-progress-bar";
import StepperProgressBar3Items from "../../assets/svg/stepper-progress-bar-3-items";
import StepperProgressBarMobile from "../../assets/svg/stepper-progress-bar-mobile";
import StepperProgressBarMobileNextLine from "../../assets/svg/stepper-progress-bar-mobile-nextline";
import useViewportWidth from "./useViewportWidth";
import StepperProgressBarMobileNextLineFp from "../../assets/svg/stepper-progress-bar-mobile-nextline-fp";
interface StepperProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  items?: StepperInterface[];
  activeStep?: number;
}

const getStepperItemVariant = (index: number, activeStep?: number) => {
  if (!activeStep) {
    return "active";
  }

  if (index + 1 < activeStep) {
    return "completed";
  } else if (index + 1 > activeStep) {
    return "disabled";
  } else {
    return "active";
  }
};

function getStepperItemVariantMobile(indexFrom1: number, activeStep: number) {
  if (indexFrom1 < activeStep) {
    return "completed";
  }
  if (indexFrom1 > activeStep) {
    return "disabled";
  }
  return "active";
}

function Stepper({ activeStep = 1, ...props }: StepperProps) {
  const isDesktopView = useViewportWidth();
  if (isDesktopView) {
    return (
      <div className="polymer-stepper" style={{ ...props.style }}>
        {props.items?.map((e, _index) => {
          return (
            <div key={e.title} onClick={() => {}} className="polymer-stepper__item-container">
              <StepperItem
                variant={getStepperItemVariant(_index, activeStep)}
                step={(_index + 1).toString()}
                title={e.title}
                marginBottom="8px"
                borderWidth={4}
              />
              {props.items && _index + 1 < props.items?.length && (
                <div className="polymer-stepper-progress-bar-wrapper">{props.items.length > 3 ? <StepperProgressBar /> : <StepperProgressBar3Items />}</div>
              )}
            </div>
          );
        })}
      </div>
    );
  } else {
    return (
        <div style={{display: "flex", justifyContent: "center"}}>
          <div className={`polymer-stepper-mobile ${(props.items && props.items?.length > 3) && "dynamic-padding" }`}>
            {props.items?.map((item, index) => {
              const rowIndex = Math.ceil((index + 1) / 3);
              const isOddNumberedRow = rowIndex % 2 !== 0;
              const columnIndex = (index + 1) % 3;
              const isLastItem = index + 1 === props.items?.length;

              if (isOddNumberedRow) {
                const isLastColumn = columnIndex % 3 === 0;
                return (
                  <div className="polymer-stepper-mobile-item-wrapper" key={item.title}>
                    <StepperItem
                      size={52}
                      variant={getStepperItemVariantMobile(index + 1, activeStep)}
                      step={(index + 1).toString()}
                      title={item.title}
                      borderWidth={4}
                    />
                    {!isLastItem && (isLastColumn ? (
                      <div className={`polymer-stepper-mobile-new-row-progress-bar-wrapper ${item.title === "Current Owners' Financial Plan" ? "polymer-stepper-mobile-new-row-progress-bar-wrapper-fp" : ""}`}>
                        {item.title !== "Current Owners' Financial Plan" ? <StepperProgressBarMobileNextLine /> : <StepperProgressBarMobileNextLineFp />}
                      </div>
                    ) : (
                      <div className="polymer-stepper-mobile-progress-bar-wrapper">
                        <StepperProgressBarMobile />
                      </div>
                    ))}
                  </div>
                );
              } else {
                const reversedColumnIndex = 4 - columnIndex;
                return (
                  <div
                    key={item.title}
                    className="polymer-stepper-mobile-item-wrapper"
                    style={{ gridColumnStart: reversedColumnIndex, gridColumnEnd: reversedColumnIndex + 1, gridRowStart: rowIndex, gridRowEnd: rowIndex + 1 }}
                  >
                    <StepperItem
                      size={52}
                      variant={getStepperItemVariantMobile(index + 1, activeStep)}
                      step={(index + 1).toString()}
                      title={item.title}
                      borderWidth={4}
                    />
                    {!isLastItem && (
                      <div className="polymer-stepper-mobile-progress-bar-wrapper reverse">
                        <StepperProgressBarMobile />
                      </div>
                    )}
                  </div>
                );
              }
            })}
          </div>
        </div>
    );
  }
}

export default Stepper;
